// import CheckPlatList from '@/pages/ReturnCheck/CheckPlant';
// import CheckPlatDetail from '@/pages/ReturnCheck/CheckPlant/Detail';
// import CheckDetailList from '@/pages/ReturnCheck/CheckDetail';
// import CheckAbnorList from '@/pages/ReturnCheck/CheckAbnor';
// import CheckStepList from '@/pages/ReturnCheck/CheckStep';
// import ReturnOrderList from '@/pages/ReturnOrder/List';
// import ReturnReceiveList from '@/pages/ReturnReceive/Receive';
// import ReceiveDetailList from '@/pages/ReturnReceive/Detail';
// import ReceiveStepList from '@/pages/ReturnReceive/Step';
// import ReceiptAbnortList from '@/pages/ReturnReceive/Abort';
// import ReturnSimpleDetail from '@/pages/ReturnReceive/Receive/SimpleDetail';
// import ReturnServiceDetail from '@/pages/ReturnReceive/Receive/ServiceDetail';
// import ReturnOrderDetail from '@/pages/ReturnOrder/Detail';
// import ReturnSkuList from '@/pages/ReturnSku/index';
// import ReturnExceptionList from '@/pages/ReturnException/List';
// import ReturnExceptionEdit from '@/pages/ReturnException/Edit';
import React from 'react';

export default [
  {
    path: '/returnService/ReturnCheck/plantList',
    // component: CheckPlatList,
    component: React.lazy(() => import(/* webpackChunkName: 'CheckPlatList' */ '@/pages/ReturnCheck/CheckPlant')),
  },
  {
    path: '/returnService/ReturnCheck/plantDetail',
    // component: CheckPlatDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'CheckPlatDetail' */ '@/pages/ReturnCheck/CheckPlant/Detail'),
    ),
  },
  {
    path: '/returnService/ReturnCheck/detailList',
    // component: CheckDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'CheckDetailList' */ '@/pages/ReturnCheck/CheckDetail')),
  },
  {
    path: '/returnService/ReturnCheck/abortList',
    // component: CheckAbnorList,
    component: React.lazy(() => import(/* webpackChunkName: 'CheckAbnorList' */ '@/pages/ReturnCheck/CheckAbnor')),
  },
  {
    path: '/returnService/ReturnCheck/stepList',
    // component: CheckStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'CheckStepList' */ '@/pages/ReturnCheck/CheckStep')),
  },
  {
    path: '/returnService/ReturnOrder/list',
    // component: ReturnOrderList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnOrderList' */ '@/pages/ReturnOrder/List')),
  },
  {
    path: '/returnService/ReturnOrder/detail',
    // component: ReturnOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnOrderDetail' */ '@/pages/ReturnOrder/Detail')),
  },
  {
    path: '/returnService/returnServiceOrder/detail/:tid',
    component: React.lazy(
      () => import(/* webpackChunkName: 'BounceServiceOrderDetail' */ '@/pages/ReturnServiceOrderDetail'),
    ),
  },
  {
    path: '/returnService/receive/receiveList',
    // component: ReturnReceiveList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnReceiveList' */ '@/pages/ReturnReceive/Receive')),
  },
  {
    path: '/returnService/receive/simpleDetail',
    // component: ReturnSimpleDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'ReturnSimpleDetail' */ '@/pages/ReturnReceive/Receive/SimpleDetail'),
    ),
  },
  {
    path: '/returnService/receive/serviceDetail',
    // component: ReturnServiceDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'ReturnServiceDetail' */ '@/pages/ReturnReceive/Receive/ServiceDetail'),
    ),
  },
  {
    path: '/returnService/receive/detailList',
    // component: ReceiveDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiveDetailList' */ '@/pages/ReturnReceive/Detail')),
  },
  {
    path: '/returnService/receive/stepList',
    // component: ReceiveStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiveStepList' */ '@/pages/ReturnReceive/Step')),
  },
  {
    path: '/returnService/receive/abortList',
    // component: ReceiptAbnortList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptAbnortList' */ '@/pages/ReturnReceive/Abort')),
  },
  {
    path: '/returnService/sku/list',
    // component: ReturnSkuList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnSkuList' */ '@/pages/ReturnSku/index')),
  },
  {
    path: '/returnService/exception/list',
    // component: ReturnExceptionList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnExceptionList' */ '@/pages/ReturnException/List')),
  },
  {
    path: '/returnService/exception/edit',
    // component: ReturnExceptionEdit,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnExceptionEdit' */ '@/pages/ReturnException/Edit')),
  },
  {
    path: '/returnService/returnstorage/list',
    // component: ReturnOrderList,
    component: React.lazy(() => import(/* webpackChunkName: 'returnstorage' */ '@/pages/ReturnStorage/List')),
  },
  {
    path: '/returnService/returnstorage/detail',
    // component: ReturnOrderList,
    component: React.lazy(() => import(/* webpackChunkName: 'returnstorage' */ '@/pages/ReturnStorage/Detail')),
  },
];
